import { render, staticRenderFns } from "./designForm.vue?vue&type=template&id=470708fb&scoped=true&"
import script from "./designForm.vue?vue&type=script&lang=js&"
export * from "./designForm.vue?vue&type=script&lang=js&"
import style0 from "./designForm.vue?vue&type=style&index=0&id=470708fb&scoped=true&lang=css&"
import style1 from "./designForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470708fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/botter-dashbaord/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VBtnToggle } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VBtnToggle,VExpansionPanel,VExpansionPanelContent,VFlex,VLayout,VTextField})
